export default {
  $getway: 'ZjStata',
  getList: 'chartConfig/list', // 获取列表
  saveEchart: 'chartConfig/save', // 保存
  getDetail: 'chartConfig/detail', // 详情
  toDelete: 'chartConfig/delete' // 删除
};
